<template>
  <div id="chats_side_panel" class="flex flex-col h-full">
    <div class="flex-1 min-h-0 overflow-hidden">
      <component :is="currentComponent" @toggle-view="handleToggleView" />
    </div>
  </div>
</template>

<script setup>
import { ref, shallowRef } from "vue";
import {
  chatViews,
  chatViewComponentMap,
} from "@/src/constants/chatConstants.js";
const currentView = ref(chatViews.BROWSER);
const currentComponent = shallowRef(chatViewComponentMap[currentView.value]);

const handleToggleView = (view) => {
  try {
    if (chatViewComponentMap[view]) {
      currentView.value = view;
      currentComponent.value = chatViewComponentMap[view];
    } else {
      console.error(`View ${view} not found in chat view component map`);
    }
  } catch (error) {
    console.error("An error occurred while toggling view: ", error);
  }
};
</script>
